import Papa from 'papaparse'

const DEFAULT_OPTIONS = {
  header: true,
  skipEmptyLines: true,
  delimiter: ''
}

export function parseCSV (file, options = {}) {
  const mergedOptions = { ...DEFAULT_OPTIONS, ...options }

  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: mergedOptions.header,
      skipEmptyLines: mergedOptions.skipEmptyLines,
      delimiter: mergedOptions.delimiter,
      complete: (results) => {
        const columns = results.meta.fields?.filter((field) => !field.startsWith('__')) || []
        const data = results.data.map((row, index) => ({ ...row, __rowIndex: index }))
        const parseErrors = results.errors.map((error) => ({
          type: error.type,
          code: error.code,
          message: error.message,
          row: error.row
        }))

        if (data.length === 0) {
          const message = parseErrors.map((error) => error.message).join(', ')
          reject(new Error(message || 'Empty CSV'))
          return
        }

        resolve({ data, columns, parseErrors })
      },
      error: (error) => reject(error)
    })
  })
}

export function toCSV (data, columns) {
  const cleanData = data.map((row) => {
    const clean = {}
    const keys = columns || Object.keys(row)

    keys.forEach((key) => {
      if (!key.startsWith('__')) clean[key] = row[key]
    })

    return clean
  })

  return Papa.unparse(cleanData, {
    columns: columns?.filter((column) => !column.startsWith('__'))
  })
}

export function downloadCSV (data, filename, columns) {
  const csv = toCSV(data, columns)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  link.click()
  URL.revokeObjectURL(url)
}
